export default __webpack_public_path__ + "static/media/female.6e550772.svg";